import { headlineFeed } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function HeadlineGrid() {
  return (
    <section id="headlines" className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          kicker="Headlines"
          title="爆款头条 · 每日更新"
          desc="封面驱动的头条位，只放当天最有可能爆的那几条。图片、标题、热度一眼就能读完。"
        />

        <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-2">
          {headlineFeed.map((item) => (
            <article
              key={item.id}
              className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
            >
              <div className="relative h-52 overflow-hidden bg-background-200 md:h-60">
                <img
                  src={item.image}
                  alt={item.title}
                  title={`${item.category} - ${item.title}`}
                  className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <span className="absolute left-4 top-4 rounded-full bg-background-50/90 px-3 py-1 text-xs font-medium text-foreground-900 backdrop-blur-sm">
                  {item.category}
                </span>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-heading text-lg font-bold leading-snug text-foreground-950 md:text-xl">
                  <a href="#most-discussed" className="transition-colors hover:text-primary-600">
                    {item.title}
                  </a>
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-4 text-xs text-foreground-500">
                  <span className="flex items-center gap-1.5 font-label text-primary-600">
                    <i className="ri-fire-line" />
                    {item.heat}
                  </span>
                  <span className="flex items-center gap-1.5">
                    <i className="ri-time-line" />
                    {item.time}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}